import { enablePointerEvents } from '@utils/pointer-events-control';
import { config, gameState } from '@js/state';

let attempts = 0; // wrong attempts on the current question
let numAnswers = 0; // remaining correct answers for current question
let boolAns = false;
let hintOn = false;
let mul = 0; // gap multiplier for correct counters
let newNum = 0;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameScene' });
  }

  preload() {}

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    this.cardHover = this.sound.add('cardHover').setVolume(0.02);

    config.audio.yayAudio = this.sound.add('yayAudio').setVolume(0.1);

    this.cardCorrectAudio = this.sound.add('correctCard').setVolume(0.05);
    this.cardIncorrectAudio = this.sound.add('incorrectCard').setVolume(0.05);
    this.masterCardFlip = this.sound.add('masterCardFlip').setVolume(0.02);
    this.cardDistribute = this.sound.add('cardDis').setVolume(0.02);
    this.cardShuffleAudio = this.sound.add('cardShuffleAudio').setVolume(0.02);
    this.levelEnd = this.sound.add('levelComplete').setVolume(0.02);

    this.answers = [];

    gameState.score = 1;
    gameState.attempted = 1;
    this.correctAnswer = 0;
    gameState.questionNumber = 0;

    this.add.sprite(config.width / 2, config.height / 2, 'mainBG');
    this.add.sprite(500.5, 20, 'correctCounter').setOrigin(0);

    this.cardDeckAnim();
    this.cardIncorrectAnim();
    this.cardCorrectAnim();
    this.createCards();

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, 'overlay')
      .setVisible(false)
      .setDepth(2);

    this.hintSystem();
    this.cardDistribute.play();
    this.cardMoveDown(this.card_1, 200, 114 + this.card_1.width / 2);
    this.cardMoveDown(this.card_3, 400, 388 + this.card_2.width / 2);
    this.cardMoveDown(this.card_4, 500, 525 + this.card_3.width / 2);
    this.cardMoveDown(this.card_2, 300, 251 + this.card_4.width / 2);
    this.cardMoveDown(this.card_6, 700, 799 + this.card_5.width / 2);
    this.cardMoveDown(this.card_5, 600, 662 + this.card_6.width / 2);
    this.cardMoveDown(this.card_7, 800, 936 + this.card_7.width / 2);
    this.cardMoveDown(this.card_8, 900, 1073 + this.card_8.width / 2);

    this.changeQuestion();

    this.cardHoverEvents(this.card_1);
    this.cardHoverEvents(this.card_2);
    this.cardHoverEvents(this.card_3);
    this.cardHoverEvents(this.card_4);
    this.cardHoverEvents(this.card_5);
    this.cardHoverEvents(this.card_6);
    this.cardHoverEvents(this.card_7);
    this.cardHoverEvents(this.card_8);

    this.card_1.on(
      'pointerup',
      () => {
        if (gameState.questionNumber == 6) {
          this.card_1.removeInteractive();
          this.card_1.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_1, 'card_6_1');
        } else if (gameState.questionNumber == 7) {
          this.card_1.removeInteractive();
          this.card_1.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_1, 'card_7_1');
        } else {
          this.card_1.setScale(1);
          attempts++;
          this.flipCardIncorrect(300, this.card_1, 'card_' + gameState.questionNumber + '_1');
          this.checkAttempts();
        }
      },
      this,
    );

    this.card_2.on(
      'pointerup',
      () => {
        if (gameState.questionNumber == 2) {
          this.card_2.removeInteractive();
          this.card_2.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_2, 'card_2_2');
        } else if (gameState.questionNumber == 4) {
          this.card_2.removeInteractive();
          this.card_2.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_2, 'card_4_2');
        } else if (gameState.questionNumber == 6) {
          this.card_2.removeInteractive();
          this.card_2.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_2, 'card_6_2');
        } else if (gameState.questionNumber == 8) {
          this.card_2.removeInteractive();
          this.card_2.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_2, 'card_8_2');
        } else if (gameState.questionNumber == 5) {
          this.card_2.removeInteractive();
          this.card_2.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_2, 'card_5_2');
        } else if (gameState.questionNumber == 9) {
          this.card_2.removeInteractive();
          this.card_2.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_2, 'card_9_2');
        } else {
          this.card_2.setScale(1);
          attempts++;
          this.flipCardIncorrect(300, this.card_2, 'card_' + gameState.questionNumber + '_2');
          this.checkAttempts();
        }
      },
      this,
    );

    this.card_3.on(
      'pointerup',
      () => {
        if (gameState.questionNumber == 6) {
          this.card_3.removeInteractive();
          this.card_3.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_3, 'card_6_3');
        } else if (gameState.questionNumber == 7) {
          this.card_3.removeInteractive();
          this.card_3.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_3, 'card_7_3');
        } else if (gameState.questionNumber == 10) {
          this.card_3.removeInteractive();
          this.card_3.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_3, 'card_10_3');
        } else {
          this.card_3.setScale(1);
          attempts++;
          this.flipCardIncorrect(300, this.card_3, 'card_' + gameState.questionNumber + '_3');
          this.checkAttempts();
        }
      },
      this,
    );

    this.card_4.on(
      'pointerup',
      () => {
        if (gameState.questionNumber == 2) {
          this.card_4.removeInteractive();
          this.card_4.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_4, 'card_2_4');
        } else if (gameState.questionNumber == 3) {
          this.card_4.removeInteractive();
          this.card_4.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_4, 'card_3_4');
        } else if (gameState.questionNumber == 8) {
          this.card_4.removeInteractive();
          this.card_4.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_4, 'card_8_4');
        } else if (gameState.questionNumber == 5) {
          this.card_4.removeInteractive();
          this.card_4.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_4, 'card_5_4');
        } else {
          this.card_4.setScale(1);
          attempts++;
          this.flipCardIncorrect(300, this.card_4, 'card_' + gameState.questionNumber + '_4');
          this.checkAttempts();
        }
      },
      this,
    );

    this.card_5.on(
      'pointerup',
      () => {
        if (gameState.questionNumber == 1) {
          this.card_5.removeInteractive();
          this.card_5.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_5, 'card_1_5');
        } else if (gameState.questionNumber == 4) {
          this.card_5.removeInteractive();
          this.card_5.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_5, 'card_4_5');
        } else if (gameState.questionNumber == 7) {
          this.card_5.removeInteractive();
          this.card_5.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_5, 'card_7_5');
        } else if (gameState.questionNumber == 8) {
          this.card_5.removeInteractive();
          this.card_5.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_5, 'card_8_5');
        } else if (gameState.questionNumber == 10) {
          this.card_5.removeInteractive();
          this.card_5.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_5, 'card_10_5');
        } else if (gameState.questionNumber == 9) {
          this.card_5.removeInteractive();
          this.card_5.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_5, 'card_9_5');
        } else {
          this.card_5.setScale(1);
          attempts++;
          this.flipCardIncorrect(300, this.card_5, 'card_' + gameState.questionNumber + '_5');
          this.checkAttempts();
        }
      },
      this,
    );

    this.card_6.on(
      'pointerup',
      () => {
        if (gameState.questionNumber == 3) {
          this.card_6.removeInteractive();
          this.card_6.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_6, 'card_3_6');
        } else if (gameState.questionNumber == 5) {
          this.card_6.removeInteractive();
          this.card_6.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_6, 'card_5_6');
        } else {
          this.card_6.setScale(1);
          attempts++;
          this.flipCardIncorrect(300, this.card_6, 'card_' + gameState.questionNumber + '_6');
          this.checkAttempts();
        }
      },
      this,
    );

    this.card_7.on(
      'pointerup',
      () => {
        if (gameState.questionNumber == 2) {
          this.card_7.removeInteractive();
          this.card_7.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_7, 'card_2_7');
        } else if (gameState.questionNumber == 4) {
          this.card_7.removeInteractive();
          this.card_7.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_7, 'card_4_7');
        } else if (gameState.questionNumber == 7) {
          this.card_7.removeInteractive();
          this.card_7.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_7, 'card_7_7');
        } else if (gameState.questionNumber == 8) {
          this.card_7.removeInteractive();
          this.card_7.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_7, 'card_8_7');
        } else {
          this.card_7.setScale(1);
          attempts++;
          this.flipCardIncorrect(300, this.card_7, 'card_' + gameState.questionNumber + '_7');
          this.checkAttempts();
        }
      },
      this,
    );

    this.card_8.on(
      'pointerup',
      () => {
        if (gameState.questionNumber == 1) {
          this.card_8.removeInteractive();
          this.card_8.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_8, 'card_1_8');
        } else if (gameState.questionNumber == 3) {
          this.card_8.removeInteractive();
          this.card_8.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_8, 'card_3_8');
        } else if (gameState.questionNumber == 4) {
          this.card_8.removeInteractive();
          this.card_8.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_8, 'card_4_8');
        } else if (gameState.questionNumber == 10) {
          this.card_8.removeInteractive();
          this.card_8.setScale(1);
          boolAns = true;
          this.timetoShuffle();
          this.correctAnswer++;
          this.flipCardCorrectIncorrect(300, this.card_8, 'card_10_8');
        } else {
          this.card_8.setScale(1);
          attempts++;
          this.flipCardIncorrect(300, this.card_8, 'card_' + gameState.questionNumber + '_8');
          this.checkAttempts();
        }
      },
      this,
    );
  }

  hintSystem() {
    this.hint = this.add.sprite(240, 575, 'hint_1').setScale(0.8).setVisible(false).setDepth(3);
    this.closeHintButton = this.add
      .sprite(435, 485, 'closeHint')
      .setVisible(false)
      .setDepth(3)
      .setInteractive({ cursor: 'pointer' });

    this.hintButton = this.add
      .sprite(80, 650, 'hintFinalAnim')
      .setScale(0.8)
      .setDepth(3)
      .setInteractive({ cursor: 'pointer' });
    this.hintButton.disableInteractive();

    this.anims.create({
      key: 'pop',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'breathe',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'idle',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'pop_out',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.hintButton.on(
      'pointerup',
      function () {
        gameState.hints += 1;
        this.hintButton.play('idle');

        for (let i = 1; i < 9; i++) {
          this['card_' + i].removeInteractive();
        }

        if (attempts == 1) {
          this.hint.setTexture('hint_1');
          this.overlay.setVisible(true);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture('hint_2');
        }
      },
      this,
    );

    this.closeHintButton.on(
      'pointerup',
      function () {
        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play('pop_out');
        this.hintButton.disableInteractive();

        for (let i = 1; i < 9; i++) {
          this['card_' + i].setInteractive({ cursor: 'pointer' });
        }

        hintOn = false;
      },
      this,
    );
  }

  setCardsInteractive() {
    this.time.delayedCall(
      4500,
      () => {
        for (let i = 1; i < 9; i++) {
          this['card_' + i].setInteractive({ cursor: 'pointer' });
        }
      },
      [],
      this,
    );
  }

  changeQuestion() {
    gameState.questionNumber += 1;
    attempts = 0;
    hintOn = false;

    this.setCardsInteractive();
    this.time.delayedCall(
      1200,
      function () {
        this.time.delayedCall(
          1700,
          () => {
            this.masterCardFlip.play();
          },
          this,
        );
        if (gameState.questionNumber == 1) {
          this.flipCard(200, this.card_1, 'card_1_1');
          this.flipCard(300, this.card_2, 'card_1_2');
          this.flipCard(400, this.card_3, 'card_1_3');
          this.flipCard(500, this.card_4, 'card_1_4');
          this.flipCard(600, this.card_5, 'card_1_5');
          this.flipCard(700, this.card_6, 'card_1_6');
          this.flipCard(800, this.card_7, 'card_1_7');
          this.flipCard(900, this.card_8, 'card_1_8');
          this.flipCard(2000, this.masterCard, 'masterCard_1');
          numAnswers = 2;
          newNum = 2;
        }
        if (gameState.questionNumber == 2) {
          this.flipCard(200, this.card_1, 'card_2_1');
          this.flipCard(300, this.card_2, 'card_2_2');
          this.flipCard(400, this.card_3, 'card_2_3');
          this.flipCard(500, this.card_4, 'card_2_4');
          this.flipCard(600, this.card_5, 'card_2_5');
          this.flipCard(700, this.card_6, 'card_2_6');
          this.flipCard(800, this.card_7, 'card_2_7');
          this.flipCard(900, this.card_8, 'card_2_8');
          this.flipCard(2000, this.masterCard, 'masterCard_2');
          numAnswers = 3;
          newNum = 3;
        }
        if (gameState.questionNumber == 3) {
          this.flipCard(200, this.card_1, 'card_3_1');
          this.flipCard(300, this.card_2, 'card_3_2');
          this.flipCard(400, this.card_3, 'card_3_3');
          this.flipCard(500, this.card_4, 'card_3_4');
          this.flipCard(600, this.card_5, 'card_3_5');
          this.flipCard(700, this.card_6, 'card_3_6');
          this.flipCard(800, this.card_7, 'card_3_7');
          this.flipCard(900, this.card_8, 'card_3_8');
          this.flipCard(2000, this.masterCard, 'masterCard_3');
          numAnswers = 3;
          newNum = 3;
        }
        if (gameState.questionNumber == 4) {
          this.flipCard(200, this.card_1, 'card_4_1');
          this.flipCard(300, this.card_2, 'card_4_2');
          this.flipCard(400, this.card_3, 'card_4_3');
          this.flipCard(500, this.card_4, 'card_4_4');
          this.flipCard(600, this.card_5, 'card_4_5');
          this.flipCard(700, this.card_6, 'card_4_6');
          this.flipCard(800, this.card_7, 'card_4_7');
          this.flipCard(900, this.card_8, 'card_4_8');
          this.flipCard(2000, this.masterCard, 'masterCard_4');
          numAnswers = 4;
          newNum = 4;
        }
        if (gameState.questionNumber == 5) {
          this.flipCard(200, this.card_1, 'card_5_1');
          this.flipCard(300, this.card_2, 'card_5_2');
          this.flipCard(400, this.card_3, 'card_5_3');
          this.flipCard(500, this.card_4, 'card_5_4');
          this.flipCard(600, this.card_5, 'card_5_5');
          this.flipCard(700, this.card_6, 'card_5_6');
          this.flipCard(800, this.card_7, 'card_5_7');
          this.flipCard(900, this.card_8, 'card_5_8');
          this.flipCard(2000, this.masterCard, 'masterCard_5');
          numAnswers = 3;
          newNum = 3;
        }
        if (gameState.questionNumber == 6) {
          this.flipCard(200, this.card_1, 'card_6_1');
          this.flipCard(300, this.card_2, 'card_6_2');
          this.flipCard(400, this.card_3, 'card_6_3');
          this.flipCard(500, this.card_4, 'card_6_4');
          this.flipCard(600, this.card_5, 'card_6_5');
          this.flipCard(700, this.card_6, 'card_6_6');
          this.flipCard(800, this.card_7, 'card_6_7');
          this.flipCard(900, this.card_8, 'card_6_8');
          this.flipCard(2000, this.masterCard, 'masterCard_6');
          numAnswers = 3;
          newNum = 3;
        }
        if (gameState.questionNumber == 7) {
          this.flipCard(200, this.card_1, 'card_7_1');
          this.flipCard(300, this.card_2, 'card_7_2');
          this.flipCard(400, this.card_3, 'card_7_3');
          this.flipCard(500, this.card_4, 'card_7_4');
          this.flipCard(600, this.card_5, 'card_7_5');
          this.flipCard(700, this.card_6, 'card_7_6');
          this.flipCard(800, this.card_7, 'card_7_7');
          this.flipCard(900, this.card_8, 'card_7_8');
          this.flipCard(2000, this.masterCard, 'masterCard_7');
          numAnswers = 4;
          newNum = 4;
        }
        if (gameState.questionNumber == 8) {
          this.flipCard(200, this.card_1, 'card_8_1');
          this.flipCard(300, this.card_2, 'card_8_2');
          this.flipCard(400, this.card_3, 'card_8_3');
          this.flipCard(500, this.card_4, 'card_8_4');
          this.flipCard(600, this.card_5, 'card_8_5');
          this.flipCard(700, this.card_6, 'card_8_6');
          this.flipCard(800, this.card_7, 'card_8_7');
          this.flipCard(900, this.card_8, 'card_8_8');
          this.flipCard(2000, this.masterCard, 'masterCard_8');
          numAnswers = 4;
          newNum = 4;
        }
        if (gameState.questionNumber == 9) {
          this.flipCard(200, this.card_1, 'card_9_1');
          this.flipCard(300, this.card_2, 'card_9_2');
          this.flipCard(400, this.card_3, 'card_9_3');
          this.flipCard(500, this.card_4, 'card_9_4');
          this.flipCard(600, this.card_5, 'card_9_5');
          this.flipCard(700, this.card_6, 'card_9_6');
          this.flipCard(800, this.card_7, 'card_9_7');
          this.flipCard(900, this.card_8, 'card_9_8');
          this.flipCard(2000, this.masterCard, 'masterCard_9');
          numAnswers = 2;
          newNum = 2;
        }
        if (gameState.questionNumber == 10) {
          this.flipCard(200, this.card_1, 'card_10_1');
          this.flipCard(300, this.card_2, 'card_10_2');
          this.flipCard(400, this.card_3, 'card_10_3');
          this.flipCard(500, this.card_4, 'card_10_4');
          this.flipCard(600, this.card_5, 'card_10_5');
          this.flipCard(700, this.card_6, 'card_10_6');
          this.flipCard(800, this.card_7, 'card_10_7');
          this.flipCard(900, this.card_8, 'card_10_8');
          this.flipCard(2000, this.masterCard, 'masterCard_10');
          numAnswers = 3;
          newNum = 3;
        }
      },
      [],
      this,
    );
  }

  cardHoverEvents(card) {
    card.on(
      'pointerover',
      () => {
        this.cardHover.play();
        card.y -= 8;
      },
      this,
    );

    card.on(
      'pointerout',
      () => {
        card.y += 8;
      },
      this,
    );

    card.on(
      'pointerdown',
      () => {
        card.setScale(0.9);
      },
      this,
    );
  }

  cardCorrectAnim() {
    this.anims.create({
      key: 'flip-correct',
      frames: this.anims.generateFrameNames('correctCardFlip', {
        start: 9,
        end: 84,
        zeroPad: 0,
        prefix: 'CORRECT0',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  cardIncorrectAnim() {
    this.anims.create({
      key: 'flip-incorrect',
      frames: this.anims.generateFrameNames('wrongCardFlip', {
        start: 9,
        end: 76,
        zeroPad: 0,
        prefix: 'WRONGFLIP',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  confettiAnim() {
    this.confetti = this.add.sprite(config.width / 2, 350, 'confettiAnim').setDepth(3);
    this.anims.create({
      key: 'confettiPlay',
      frames: this.anims.generateFrameNames('confettiAnim', {
        start: 0,
        end: 122,
        zeroPad: 0,
        prefix: 'CONFETTI0',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });
    this.confetti.playAfterDelay('confettiPlay', 1500);
  }

  flipCardIncorrect(delay, card, cardFront) {
    this.time.delayedCall(
      delay,
      () => {
        this.tweens.chain({
          targets: card,
          tweens: [
            {
              scale: 1.1,
              duration: 100,
            },
            {
              scaleX: 0,
              duration: 200,
              delay: 100,
              onComplete: () => {
                card.setScale(1);
                card.scaleX = 1;
                card.setTexture('wrongCardFlip');
                this.cardIncorrectAudio.play();
                card.play('flip-incorrect');

                card.on(
                  Phaser.Animations.Events.ANIMATION_COMPLETE,
                  () => {
                    if (card.y < 382) {
                      card.y += 8;
                    }

                    this.tweens.chain({
                      targets: card,
                      tweens: [
                        {
                          scale: 1.1,
                          duration: 100,
                          delay: 300,
                        },
                        {
                          scaleX: 0,
                          duration: 200,
                          delay: 100,
                          onComplete: () => {
                            card.setTexture(cardFront);
                          },
                        },
                        {
                          scaleX: 1.1,
                          duration: 200,
                        },
                        {
                          scale: 1,
                          duration: 100,
                        },
                      ],
                    });
                  },
                  this,
                );
              },
            },
            {
              scaleX: 1.1,
              duration: 200,
            },
            {
              scale: 1,
              duration: 100,
            },
          ],
        });

        if (boolAns) {
          if (hintOn) {
            this.hintButton.play('pop_out');
            hintOn = false;
          }
        }
      },
      [],
      this,
    );
  }

  flipCardCorrectIncorrect(delay, card, cardFront) {
    this.time.delayedCall(
      delay,
      () => {
        this.tweens.chain({
          targets: card,
          tweens: [
            {
              scale: 1.1,
              duration: 100,
            },
            {
              scaleX: 0,
              duration: 200,
              delay: 100,
              onComplete: () => {
                card.setScale(1);
                card.scaleX = 1;

                if (boolAns) {
                  card.setTexture('correctCardFlip');
                  this.cardCorrectAudio.play();
                  card.play('flip-correct');
                }

                card.on(
                  Phaser.Animations.Events.ANIMATION_COMPLETE,
                  () => {
                    if (card.y < 382) {
                      card.y += 8;
                    }

                    this.tweens.chain({
                      targets: card,
                      tweens: [
                        {
                          scale: 1.1,
                          duration: 100,
                          delay: 300,
                        },
                        {
                          scaleX: 0,
                          duration: 200,
                          delay: 100,
                          onComplete: () => {
                            card.setTexture(cardFront);
                          },
                        },
                        {
                          scaleX: 1.1,
                          duration: 200,
                        },
                        {
                          scale: 1,
                          duration: 100,
                        },
                      ],
                    });
                  },
                  this,
                );
              },
            },
            {
              scaleX: 1.1,
              duration: 200,
            },
            {
              scale: 1,
              duration: 100,
            },
          ],
        });

        if (boolAns) {
          if (hintOn) {
            this.hintButton.play('pop_out');
            hintOn = false;
          }

          this.time.delayedCall(
            4000,
            () => {
              this.cardCollect(card);
            },
            [],
            this,
          );
        }
      },
      [],
      this,
    );
  }

  checkAttempts() {
    if (attempts == 1 || attempts == 2) {
      this.hintButton.setInteractive();
      hintOn = true;
      this.hintButton.play('pop');
      this.time.delayedCall(
        1500,
        function () {
          if (hintOn) {
            this.hintButton.play('breathe');
          }
        },
        [],
        this,
      );
    } else if (attempts == 3) {
      if (hintOn == true) {
        this.hintButton.play('pop_out');
        hintOn = false;
      }

      for (let i = 1; i < 9; i++) {
        this['card_' + i].disableInteractive();
      }
      gameState.attempted += 1;
      this.time.delayedCall(
        4000,
        () => {
          this.cardShuffle();
        },
        [],
        this,
      );
    }
  }

  cardMoveDown(target, delay, endX) {
    this.tweens.add({
      targets: target,
      ease: 'Sine.easeIn',
      duration: 300,
      delay: delay,
      x: endX,
      y: {
        getStart: () => 152,
        getEnd: () => 390,
      },
      yoyo: false,
      loop: 0,
    });
  }

  cardDeckAnim() {
    this.cardDeck = this.add
      .sprite(config.width / 2, 360, 'shuffleCards')
      .setOrigin(0.5)
      .setDepth(1);
    this.anims.create({
      key: 'shuffle',
      frames: this.anims.generateFrameNames('shuffleCards', {
        start: 0,
        end: 77,
        zeroPad: 0,
        prefix: 'DECKSHUFFLE',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  createCards() {
    this.card_1 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_2 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_3 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_4 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_5 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_6 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_7 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_8 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.masterCard = this.add.sprite(640, 153, 'cardBack').setOrigin(0.5).setDepth(2);
  }

  cardCollect(card) {
    this.answers.push(card);

    const curve = new Phaser.Curves.Line(
      new Phaser.Math.Vector2(592, 619),
      new Phaser.Math.Vector2(687, 619),
    );

    const points = curve.getPoints(2);

    if (this.correctAnswer == 1) {
      this.tweenAnimation(points[1].x, points[1].y, 0, this.answers[0]);
    } else if (this.correctAnswer == 2) {
      this.tweenAnimation(points[2].x, 619, 5, this.answers[0]);
      this.tweenAnimation(points[0].x, points[0].y, -5, this.answers[1]);
    } else if (this.correctAnswer == 3) {
      this.tweenAnimation(points[2].x + 47.4, points[2].y + 5, 5, this.answers[0]);
      this.tweenAnimation(points[1].x, points[0].y, 0, this.answers[1]);
      this.tweenAnimation(points[0].x - 47.4, points[0].y + 5, -5, this.answers[2]);
    } else if (this.correctAnswer == 4) {
      this.tweenAnimation(points[2].x + 47.4 + 47.4, points[2].y + 15, 10, this.answers[0]);
      this.tweenAnimation(points[1].x + 47.4, points[0].y, 5, this.answers[1]);
      this.tweenAnimation(
        points[0].x - 47.4 + 47.4,
        points[0].y + 5 - 5,
        -5,
        this.answers[2],
      );
      this.tweenAnimation(points[0].x - 47.4 - 47.4, points[0].y + 15, -10, this.answers[3]);
    }
  }

  timetoShuffle() {
    newNum--;
    if (newNum == 0) {
      for (let i = 1; i < 9; i++) {
        this['card_' + i].disableInteractive();
      }
    }
    this.time.delayedCall(
      4900,
      () => {
        numAnswers--;

        if (numAnswers == 0) {
          if (hintOn) {
            this.hintButton.play('pop_out');
            hintOn = false;
            this.hintButton.disableInteractive();
          }
          gameState.score += 1;
          gameState.attempted += 1;
          this.time.delayedCall(
            1000,
            () => {
              this.levelEnd.play();
            },
            this,
          );

          this.confettiAnim();
          this.time.delayedCall(
            1000,
            () => {
              mul++;
              if (mul == 3) {
                this.add.sprite(500.5 + mul * 48.5, 20, 'correctCounter').setOrigin(0);
              } else if (mul == 4) {
                this.add.sprite(500.5 + mul * 48.7, 20, 'correctCounter').setOrigin(0);
              } else if (mul == 5) {
                this.add.sprite(500.5 + mul * 48.7, 20, 'correctCounter').setOrigin(0);
              } else {
                this.add.sprite(500.5 + mul * 48, 20, 'correctCounter').setOrigin(0);
              }

              this.cardShuffle();
            },
            [],
            this,
          );
        }
      },
      [],
      this,
    );
  }

  tweenAnimation(endX, endY, angle, target) {
    this.tweens.add({
      targets: target,
      duration: 500,
      angle: angle,
      x: endX,
      y: endY,
      ease: 'Linear',
      onComplete: () => {},
    });
  }

  flipCard(delay, card, cardFront) {
    this.time.delayedCall(
      delay,
      () => {
        this.tweens.chain({
          targets: card,
          tweens: [
            {
              scale: 1.1,
              duration: 100,
            },
            {
              scaleX: 0,
              duration: 200,
              delay: 100,
              onComplete: () => {
                if (card.texture.key == 'cardBack') {
                  card.setTexture(cardFront);
                } else {
                  card.setTexture('cardBack');
                }
              },
            },
            {
              scaleX: 1.1,
              duration: 200,
            },
            {
              scale: 1,
              duration: 100,
            },
          ],
        });
      },
      [],
      this,
    );
  }

  cardShuffle() {
    this.tweens.add({
      targets: [
        this.card_1,
        this.card_2,
        this.card_3,
        this.card_4,
        this.card_5,
        this.card_6,
        this.card_7,
        this.card_8,
      ],
      ease: 'Sine.easeInOut',
      angle: 0,
      duration: 500,
      x: config.width / 2,
    });

    this.tweens.add({
      targets: [
        this.card_1,
        this.card_2,
        this.card_3,
        this.card_4,
        this.card_5,
        this.card_6,
        this.card_7,
        this.card_8,
      ],
      delay: 500,
      ease: 'Sine.easeInOut',
      duration: 1000,
      y: 153,
      onComplete: () => {
        this.masterCard.setDepth(5);

        this.flipCard(100, this.masterCard, 'cardBack');
        this.flipCard(100, this.card_1, 'cardBack');
        this.flipCard(100, this.card_2, 'cardBack');
        this.flipCard(100, this.card_3, 'cardBack');
        this.flipCard(100, this.card_4, 'cardBack');
        this.flipCard(100, this.card_5, 'cardBack');
        this.flipCard(100, this.card_6, 'cardBack');
        this.flipCard(100, this.card_7, 'cardBack');
        this.flipCard(100, this.card_8, 'cardBack');

        this.card_1.setVisible(false);
        this.card_2.setVisible(false);
        this.card_3.setVisible(false);
        this.card_4.setVisible(false);
        this.card_5.setVisible(false);
        this.card_6.setVisible(false);
        this.card_7.setVisible(false);
        this.card_8.setVisible(false);

        for (let i = 1; i < 9; i++) {
          this['card_' + i].disableInteractive();
        }

        if (gameState.score == 6 || gameState.attempted == 10) {
          this.time.delayedCall(2000, () => {
            this.cameras.main.fadeOut(500, 255, 255, 255);
            if (gameState.score == 6) {
              config.audio.yayAudio.play();
              gameState.gameWin = true;
            } else {
              gameState.gameWin = false;
            }

            this.cameras.main.once(
              'camerafadeoutcomplete',
              function () {
                config.audio.bgaudio.stop();
                this.scene.stop('GameScene');
                this.scene.start('EndScene');
              },
              this,
            );
          });
        }
      },
    });

    this.time.delayedCall(
      4500,
      () => {
        this.masterCard.setVisible(false);
        this.time.delayedCall(
          1000,
          () => {
            this.cardShuffleAudio.play();
          },
          this,
        );
        this.cardDeck.play('shuffle');

        this.time.delayedCall(
          2000,
          () => {
            this.changeQuestion();
            this.answers = [];
            this.correctAnswer = 0;
            boolAns = false;

            this.masterCard.setVisible(true);

            for (let i = 1; i < 9; i++) {
              this['card_' + i].setVisible(true);
            }
            this.cardDistribute.play();
            this.cardMoveDown(this.card_1, 200, 114 + this.card_1.width / 2);
            this.cardMoveDown(this.card_3, 400, 388 + this.card_2.width / 2);
            this.cardMoveDown(this.card_4, 500, 525 + this.card_3.width / 2);
            this.cardMoveDown(this.card_2, 300, 251 + this.card_4.width / 2);
            this.cardMoveDown(this.card_6, 700, 799 + this.card_5.width / 2);
            this.cardMoveDown(this.card_5, 600, 662 + this.card_6.width / 2);
            this.cardMoveDown(this.card_7, 800, 936 + this.card_7.width / 2);
            this.cardMoveDown(this.card_8, 900, 1073 + this.card_8.width / 2);
          },
          [],
          this,
        );
      },
      [],
      this,
    );
  }

  update() {}
}
